import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Global, css } from "@emotion/core"
import Header from "@nvdb-rapport/shared/src/components/Header"
import Head from "@nvdb-rapport/shared/src/components/Head"
import InfoBanner from "@nvdb-rapport/shared/src/components/InfoBanner"

const Layout = ({ children }: { children: React.ReactNode }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Global
        styles={css`
          body {
            margin: 0;
            font-family: sans-serif;
          }
        `}
      ></Global>
      <Head siteTitle={data.site.siteMetadata.title}></Head>
      <Header title={data.site.siteMetadata.title} />
      <InfoBanner />
      <div>
        <main>{children}</main>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
